function returnsModal() {
    const $content = document.getElementById('returns');

    if (!$content) {
        return;
    }

    import('../../smartpak/modal.js').then(({ default: modal }) => modal($content.cloneNode(true), {
        title: 'Free Return Shipping',
        removeContents: true,
        width: 900
    }));
}

export function returnsModalEventListener() {
    document.addEventListener('click', e => {
        if (e.target.closest('.returns-modal-trigger')) {
            e.preventDefault();
            returnsModal();
        }
    });
}
